interface StepperProps {
    totalSteps: number; 
    currentStep: number; 
    onStepClick: (index: number) => void; 
    stepperRef: React.RefObject<HTMLDivElement>;
    className?: string;
    elementWidth: number;
}

export const Stepper = ({ 
    totalSteps, 
    currentStep, 
    onStepClick, 
    stepperRef, 
    className,
    elementWidth
}: StepperProps) => {

    const handleStepClick = (index: number) => {
        onStepClick(index);
        if (stepperRef.current) {
            stepperRef.current.scrollTo({
                left: index * (elementWidth + 24) , // 225px card width + 24 px gap
                behavior: 'smooth',
            });
        }
    };

    // TODO: replace bgColor with correct tailwind classes after adding palette
    return (
        <div className={`flex gap-[6px] justify-center ${className ?? ''}`}>
            {[...Array(totalSteps).keys()].map((index) => (
                <div
                    key={index}
                    className={`w-[32px] h-[4px] cursor-pointer rounded-sm`}
                    style={{
                        backgroundColor: index === currentStep ? '#dbfe77' : '#b27ef1',
                    }}
                    onClick={() => handleStepClick(index)}
                />
            ))}
        </div>
    );
};
